import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function PublicHomePage() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat relative"
      style={{ backgroundImage: 'url(/padelbackground.png)' }}
    >
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      <div className="relative container mx-auto px-4 py-12">
        <div className="flex flex-col items-center justify-center space-y-8">
          {/* Logo */}
          <div className="w-64 h-64 md:w-80 md:h-80">
            <img
              src="/logo-original-white.svg"
              alt="TorneoPadel"
              className="w-full h-full object-contain"
            />
          </div>

          
          <p className="text-lg text-white text-center max-w-2xl">
            La plataforma definitiva para organizar y participar en torneos de pádel
          </p>

          {/* Main Action */}
          <div className="flex justify-center mt-8">
            <button
              onClick={() => navigate('/join')}
              className="px-10 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold text-lg shadow-lg"
            >
              Unirse a Torneo
            </button>
          </div>

          {/* Login/Signup Link */}
          <div className="mt-12 space-y-4">
            <div className="flex items-center justify-center gap-4">
              <Link
                to="/login"
                className="text-blue-600 hover:text-blue-800 font-medium"
              >
                Iniciar Sesión
              </Link>
              <span className="text-gray-400">|</span>
              <Link
                to="/signup"
                className="text-green-600 hover:text-green-800 font-medium"
              >
                Registrarse
              </Link>
            </div>

            {/* Organizer Waitlist Link */}
            <div className="text-center mt-4">
              <Link
                to="/organizer-waitlist"
                className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 text-yellow-800 rounded-lg hover:bg-yellow-200 transition-colors"
              >
                <span>📋</span>
                <span className="font-medium">¿Quieres ser organizador? Únete a la lista de espera</span>
              </Link>
            </div>
          </div>

          {/* Features Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 w-full max-w-4xl">
            <div className="text-center bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-4xl mb-4">🎾</div>
              <h3 className="font-semibold text-lg mb-2 text-white">Fácil de Usar</h3>
              <p className="text-gray-200">Crea y gestiona torneos en minutos</p>
            </div>
            
            <div className="text-center bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-4xl mb-4">📱</div>
              <h3 className="font-semibold text-lg mb-2 text-white">Notificaciones WhatsApp</h3>
              <p className="text-gray-200">Mantén a todos informados automáticamente</p>
            </div>
            
            <div className="text-center bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-4xl mb-4">🏆</div>
              <h3 className="font-semibold text-lg mb-2 text-white">Comparte tus Victorias</h3>
              <p className="text-gray-200">Presume tus triunfos en redes sociales</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}